import React from 'react';
import { motion } from 'framer-motion';
import './Projects.css';
import bikeImage from '../assets/bike.jpg';
import waterImage from '../assets/water.jpg';
import profileImage from '../assets/pashupati nath.jpg';
import shoppingImage from '../assets/showing-cart-trolley-shopping-online-sign-graphic.jpg';
import researchImage from '../assets/research-analysis-ideas-strategy-information-concept.jpg';
import unsplashImage1 from '../assets/carlos-muza-hpjSkU2UYSU-unsplash.jpg';
import unsplashImage2 from '../assets/vitaly-gariev-14jNrPntbgk-unsplash.jpg';
import unsplashImage3 from '../assets/mohamed-nohassi--0xMiYQmk8g-unsplash.jpg';
import productImage from '../assets/3813178.jpg';
import whatsappImage from '../assets/whatsapp-2026-03-24.jpeg';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: 'E-Commerce Platform',
      description: 'A full-stack e-commerce solution with payment integration, inventory management, and user authentication.',
      technologies: ['React', 'Node.js', 'MongoDB', 'Stripe'],
      image: shoppingImage,
      link: '#'
    },
    {
      id: 2,
      title: 'Mobile App - Fitness Tracker',
      description: 'Cross-platform mobile application built with Flutter for tracking fitness goals and workout routines.',
      technologies: ['Flutter', 'Firebase', 'Dart'],
      image: unsplashImage1,
      link: '#'
    },
    {
      id: 3,
      title: 'Tech Consulting Dashboard',
      description: 'Analytics dashboard for monitoring tech infrastructure and providing real-time insights to clients.',
      technologies: ['React', 'Chart.js', 'Express', 'PostgreSQL'],
      image: researchImage,
      link: '#'
    },
    {
      id: 4,
      title: 'Social Media Analytics Tool',
      description: 'Tool to track and analyze social media performance across multiple platforms with automated reporting.',
      technologies: ['Python', 'Django', 'React', 'AWS'],
      image: unsplashImage2,
      link: '#'
    },
    {
      id: 5,
      title: 'Educational Learning Platform',
      description: 'Online learning platform with video streaming, quizzes, and progress tracking for students.',
      technologies: ['React', 'Node.js', 'MongoDB', 'Stripe'],
      image: waterImage,
      link: '#'
    },
    {
      id: 6,
      title: 'AI Chatbot Integration',
      description: 'Intelligent chatbot system for customer support with natural language processing capabilities.',
      technologies: ['Python', 'TensorFlow', 'React', 'FastAPI'],
      image: unsplashImage3,
      link: '#'
    },
    {
      id: 7,
      title: 'Electric Bike Rental App',
      description: 'Smart bike-sharing platform with GPS tracking and subscription management.',
      technologies: ['React', 'Firebase', 'Stripe'],
      image: bikeImage,
      link: '#'
    },
    {
      id: 8,
      title: 'City Landmark Explorer',
      description: 'Interactive travel guide using AI recommendation for local points of interest.',
      technologies: ['Vue', 'Node.js', 'MongoDB'],
      image: profileImage,
      link: '#'
    },
    {
      id: 9,
      title: 'Product Inventory Visualizer',
      description: 'Inventory management dashboard with product insights and stock forecasting.',
      technologies: ['Angular', 'Express', 'PostgreSQL'],
      image: productImage,
      link: '#'
    },
    {
      id: 10,
      title: 'Business Contact Assistant',
      description: 'WhatsApp-style assistant layout for business lead snapshots and quick replies.',
      technologies: ['React', 'TypeScript', 'Tailwind CSS'],
      image: whatsappImage,
      link: '#'
    }
  ];

  return (
    <motion.div
      className="projects"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <motion.div
          className="projects-header"
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <h2>My Projects</h2>
          <p>Showcasing innovative solutions and technical implementations</p>
        </motion.div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              className="project-card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -10 }}
            >
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-overlay">
                  <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
                    View Project
                  </a>
                </div>
              </div>
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-tech">
                  {project.technologies.map((tech, idx) => (
                    <span key={idx} className="tech-badge">{tech}</span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Projects;